module.exports = __webpack_public_path__ + "6732f3d4057493716a13e86992b31eec.svg";